export function shortener (string, prefix = 6, suffix = 4, sym = '...') {
  if (!string) return ''

  if (string.length < 11) return string

  // str.replace(str.substring(6,9), '...')
  const strLength = string.length
  const substring = string.substring(prefix, strLength - suffix)
  const result = string.replace(substring, sym)
  return result
}

export function makeRandomString (length = 20) {
  let result = ''
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength))
  }
  return result
}
